<script>
    import Router, { loc, pop } from 'svelte-spa-router'
    import routes from './routes'
    import TopBar from './lib/TopBar.svelte'
    import BottomBar from './lib/BottomBar.svelte'
    import { onMount, onDestroy } from 'svelte'
    import { push } from 'svelte-spa-router'
    import { Mediator } from './lib/mediator'
    import { checkRoute, getRoutes } from './menu.js'

    import {ui} from "beercss";

    globalThis.ui = ui

    //import { redraw } from 'plotly.js-dist'

    class ScriptLoader {
    constructor (options) {
      const { src, global, protocol = document.location.protocol } = options
      this.src = src
      this.global = global
      this.protocol = protocol
      this.isLoaded = false
  }

  loadScript () {
    return new Promise((resolve, reject) => {
      // Create script element and set attributes
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = `${this.protocol}//${this.src}`

      // Append the script to the DOM
      const el = document.getElementsByTagName('script')[0]
      el.parentNode.insertBefore(script, el)

      // Resolve the promise once the script is loaded
      script.addEventListener('load', () => {
        this.isLoaded = true
        resolve(script)
      })

      // Catch any errors while loading the script
      script.addEventListener('error', () => {
        reject(new Error(`${this.src} failed to load.`))
      })
    })
  }

  load () {
    return new Promise(async (resolve, reject) => {
      if (!this.isLoaded) {
        try {
          await this.loadScript()
          resolve(window[this.global])
        } catch (e) {
          reject(e)
        }
      } else {
        alert(window[this.global])
        resolve(window[this.global])
      }
    })
  }
}

    function routeLoading(event) {

    }

onMount(async () => {
  
})

</script>

<style>
    .container {
        display: flex;
        flex-direction: column; /* Stacks children vertically */
        height: 100vh; /* Makes the container fill the full viewport height */
    }

    .content {
        flex: 1; /* This div expands to fill the remaining available space */
        overflow: auto; /* Adds a scrollbar if the content inside overflows its space */
    }
</style>

<div class="container" id="main">
    <TopBar/>
    <div class="content" id="route">
        <Router
            {routes}
            on:routeLoading={routeLoading}
        />
    </div>
    <BottomBar />
</div>

